/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface Kasha
 */
export class Kasha {
    /**
     *
     * @type {string}
     * @memberof Kasha
     */
    _id: string;
    /**
     *
     * @type {string}
     * @memberof Kasha
     */
    namespace: string;
    /**
     *
     * @type {string}
     * @memberof Kasha
     */
    type: string;
    /**
     *
     * @type {string}
     * @memberof Kasha
     */
    apiKey: string;
    /**
     *
     * @type {string}
     * @memberof Kasha
     */
    secretKey: string;
    /**
     *
     * @type {boolean}
     * @memberof Kasha
     */
    sandbox: boolean;
    /**
     *
     * @type {boolean}
     * @memberof Kasha
     */
    autoApprove: boolean;
}
